import './HelloFlex.css';

function HelloFlex() {
  return ( 
    <>
      <header></header>

      <div class="bg-wrapper">
        <img src="https://wallpapersprinted.com/download/2/star_wars_the_last_jedi-wallpaper-1280x768.jpg" alt="background" class="bg" />
      </div>
    </>
  );
}

export default HelloFlex;
